<template >
  <div class="mainbody">
    <div class="tableInfo">
      <div style="padding: 16px 32px 16px 0px">
        <span class="title" @click="passAll()">同意</span>
        <span class="title" @click="refuseAll()">拒绝</span>
        <span class="title" @click="downloadAll()">下载头像</span>
        <span
          class="title"
          style="float: right; margin-right: 0px; padding: 0"
          @click="modifyStyle()"
          >图片上传样式更改</span
        >
        <img
          src="@/assets/icon_upload.png"
          style="float: right; margin-right: 5px; margin-top: 2px"
        />
      </div>
      <div class="aLine"></div>
      <el-table
        :data="data_list"
        @row-click="showInfo"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" min-width="1"></el-table-column>
        <el-table-column
          prop="student_no"
          label="学号"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="1"
        ></el-table-column>
        <el-table-column label="头像" min-width="1">
          <template slot-scope="scope">
            <el-image
              style="cursor: pointer; width: 60px; height: 82px"
              :src="urlPath + scope.row.img_link"
              fit="cover"
              :preview-src-list="[urlPath + scope.row.img_link]"
            >
              <div
                slot="error"
                class="image-slot"
                style="position: absolute; top: 50%; left: 50%"
              >
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="提交时间"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="审核状态"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="operating"
          label="操作"
          min-width="1"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="pass(scope.row)"
              >同意</el-button
            >
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="refuse(scope.row)"
              >拒绝</el-button
            >
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="download(scope.row)"
              >下载图片</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
    <PhotoExamineDialog
      ref="_photoExamineDialog"
      @saveData="examineAlumniPhoto"
      @showRefuseDialog="showRefuseDialog"
    ></PhotoExamineDialog>
    <PhotoExamineStyleDialog
      ref="_photoExamineStyleDialog"
    ></PhotoExamineStyleDialog>
    <ExportUserPhotoDialog ref="_exportUserPhotoDialog"></ExportUserPhotoDialog>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import PhotoExamineDialog from "@/components/dialog/photoExamineDialog";
import PhotoExamineStyleDialog from "@/components/dialog/photoExamineStyleDialog";
import ExportUserPhotoDialog from "@/components/dialog/exportUserPhotoDialog";

export default {
  components: {
    PhotoExamineDialog,
    PhotoExamineStyleDialog,
    ExportUserPhotoDialog,
  },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsExamine: Constant.options_state_examine,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      selection: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList: function () {
      this.$api
        .waitReviewPhotoList({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,
          // screen_result: this.screen_result,
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.data_list.forEach((info) => {
            this.optionsExamine.forEach((examin) => {
              if (info.status == examin.value) info.status = examin.text;
            });
            info.createTime = Utils.dateFormat(info.create_time * 1000);
          });
        })
        .catch(({ error }) => {});
    },
    // 过滤
    filterChange(filters) {
      this.screen_result = StrUtils.getStr4List1(filters.filterResult);
      if (this.screen_result == "") this.screen_result = undefined;
      this.getList();
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    selectionEmpty() {
      if (this.selection.length == 0) {
        this.$message.error("至少选中一条数据");
        return true;
      }
      return false;
    },
    passAll() {
      if (this.selectionEmpty()) return;
      let log_ids = [];
      this.selection.forEach((info) => {
        log_ids.push(info.id);
      });
      this.examineAlumniPhoto(log_ids, "Y");
    },
    refuseAll() {
      if (this.selectionEmpty()) return;
      let log_ids = [];
      this.selection.forEach((info) => {
        log_ids.push(info.id);
      });
      this.showRefuseDialog(log_ids);
    },
    downloadAll() {
      if (this.selectionEmpty()) return;
      let log_ids = [];
      this.selection.forEach((info) => {
        log_ids.push(info.id);
      });
      this.$nextTick(() => {
        this.$refs._exportUserPhotoDialog.show(log_ids);
      });
    },
    showInfo(row, column, event) {
      // console.log(event.srcElement.tagName)
      // console.log(column)
      // console.log(event)
      if (column.label == "操作" || column.label == "头像") return;
      this.$nextTick(() => {
        this.$refs._photoExamineDialog.show(row);
      });
    },
    modifyStyle() {
      this.$nextTick(() => {
        this.$refs._photoExamineStyleDialog.show();
      });
    },
    examineAlumniPhoto(log_ids, is_poss, remark) {
      if (remark == undefined) remark = "";
      this.$api
        .examineAlumniPhoto({
          token: localStorage.getItem("token"),
          log_ids: JSON.stringify(log_ids),
          is_poss: is_poss,
          remark: remark,
        })
        .then(({ data }) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getList();
          this.$root.$emit("refreshPhoto");
        })
        .catch(({ error }) => {});
    },
    // 通过
    pass(row) {
      this.examineAlumniPhoto([row.id], "Y");
    },
    // 拒绝
    refuse(row) {
      this.showRefuseDialog([row.id], "N");
    },
    // 下载
    download(row) {
      this.$nextTick(() => {
        this.$refs._exportUserPhotoDialog.show([row.id]);
      });
    },
    // 拒绝
    showRefuseDialog(log_ids) {
      // this.$confirm('是否确认拒绝通过当前头像?', '拒绝通过', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消'
      // })
      //   .then(() => {
      //     this.examineAlumniPhoto(log_ids, 'N')
      //   })
      //   .catch(() => {})
      this.$prompt("是否确认拒绝通过当前头像? 请填写拒绝理由", "拒绝通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.examineAlumniPhoto(log_ids, "N", value);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .title {
  cursor: pointer;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-right: 20px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
</style>


// WEBPACK FOOTER //
// src/components/photoExamine/photoExamineWaitList.vue